<div
  class="modal-header custom-modal-header justify-content-center"
  *ngIf="showCloseButton"
>
  <h4 class="modal-title text-center w-100" id="modal-basic-title">
    {{ title }}
  </h4>
</div>

<div class="modal-body">
  <p *ngIf="isTextContent" class="mb-0 text-center" [innerHTML]="content"></p>

  <ng-container *ngIf="!isTextContent && templateContent">
    <ng-container *ngTemplateOutlet="templateContent"></ng-container>
  </ng-container>
</div>

<div
  class="modal-footer d-flex gap-2 justify-content-end"
  *ngIf="showCloseButton"
>
  <button
    *ngFor="let btn of buttons"
    type="button"
    class="btn w-auto px-3"
    [ngClass]="btn.color || 'btn-secondary'"
    [style.min-width]="btn.minWidth === 'none' ? 'auto' : btn.minWidth"
    (click)="handleAction(btn)"
  >
    {{ btn.text }}
  </button>
</div>
